import MeetingNotesContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/MeetingNotesContent";
import NGTScenarioPlayer from "../../../ngt/scenario/NGTScenarioPlayer";

export default class TeaCornerContent {
    /**
     * @constructor
     * @param {MeetingNotesContent} content 
     * @param {NGTScenarioPlayer} contentPlayer 
     */
    constructor(content, contentPlayer) {
        this._content = content;
        this._contentPlayer = contentPlayer;
    }

    get content() {
        return this._content;
    }

    get contentPlayer() {
        return this._contentPlayer;
    }
}